<div class="sticky-top">
  <header
    class="navbar page-header whiteHeader navbar-expand-lg border-bottom shadow-sm"
  >
    <div class="w-100 mx-5 d-flex justify-content-between align-items-center">
      <a class="navbar-brand d-inline-flex align-items-center" routerLink="/">
        <img
          src="assets/images/nplex_color.svg"
          alt="NPLEx Answers"
          title="NPLEx Answers"
          class="img-fluid h-28"
        />
      </a>
      <span class="font-weight-bold"
        >Need Support?
        <a
          class="text-primary contact-us"
          href="https://requests.ops.appriss.com/methcheck"
          target="_blank"
          >Contact Us</a
        >
      </span>
    </div>
  </header>
</div>
